import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getNotifications } from "./thunk";
import {
  ApiResponse,
  PaginatedPayload,
  PaginationMeta,
} from "../../types/ApiResponse";
import { NotificationPayloadData } from "types/notification.api";

type RequestStatus = "idle" | "loading" | "succeeded" | "failed";

interface NotificationStatus {
  fetch: RequestStatus;
}

interface NotificationError {
  fetch: string | null;
}

export interface NotificationState {
  notifications: NotificationPayloadData[];

  pagination: PaginationMeta;
  status: NotificationStatus;
  errors: NotificationError;
}

export const initialState: NotificationState = {
  notifications: [],
  pagination: {
    current_page: 0,
    per_page: 0,
    last_page: 0,
    total: 0,
    from: 0,
    to: 0,
    links: [],
    path: "",
  },

  status: {
    fetch: "idle",
  },

  errors: {
    fetch: null,
  },
};

const NotificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // getNotifications cases
    builder.addCase(getNotifications.pending, (state) => {
      state.status.fetch = "loading";
      state.errors.fetch = null;
    });
    builder.addCase(
      getNotifications.fulfilled,
      (
        state,
        action: PayloadAction<
          ApiResponse<PaginatedPayload<NotificationPayloadData>>
        >
      ) => {
        const responsePayload = action.payload?.payload;
        state.status.fetch = "succeeded";
        state.notifications = responsePayload?.data || [];
        state.pagination = responsePayload?.meta || initialState.pagination;
      }
    );
    builder.addCase(getNotifications.rejected, (state, action) => {
      state.status.fetch = "failed";
      state.errors.fetch = action.payload || null;
    });
  },
});

export default NotificationSlice.reducer;

export const selectNotificationsState = (state: any) =>
  state.notification as typeof initialState;
